module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Gritiy News":"Gritiy News","Händelser":"Events"},"sv":{"Gritiy News":"Gritiy News","Händelser":"Händelser"}}')
  delete Component.options._Ctor
}
